import { render } from "./Blocks.vue?vue&type=template&id=7c81ea34"
import script from "./Blocks.vue?vue&type=script&lang=js"
export * from "./Blocks.vue?vue&type=script&lang=js"

import "./Blocks.vue?vue&type=style&index=0&id=7c81ea34&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__